import React from 'react';

import {
  Dimensions,
  Platform,
  Linking,
} from 'react-native';

import * as hf from './_hf';
import * as ht from './_ht';

import { useNgnz } from './_csNgn';

export const c = ( // create element
  poType: ht.o,
  pPmrz: ht.dz,
  pClds?: ht.ls | ht.o
) => {
  return React.createElement(poType, {key: -10, ... pPmrz}, pClds);
};

export const d = (dvcType: 'p' | 's') => {
  if (dvcType == 'p' && Dimensions.get('window').width >= 1024 ) return true;
  if (dvcType == 's' && Dimensions.get('window').width <  1024 ) return true;
  return false;
};

export const chkOS = (
) => {
  if (Platform.OS === 'ios') return 'i';
  if (Platform.OS === 'web') return 'w';
  return undefined;
}

export const chkDvc = () => { // 廃止予定
  if (Dimensions.get('window').width >= 1024 ) return 'p';
  return 's';
};

export const getPrmz = (pz: ht.dz) => { // 暫定
  return pz.route.params;
};

export const moveTo = (pz: {
  pageName: ht.s,
  pmrz?: ht.dz,
}) => {
  const _sNgnz = useNgnz();
  _sNgnz.moveTo(pz)
};

export const openUrl = (pDz: {
  url: ht.s, 
  tgt?: 'url' | 'tel' | 'mail' | 'pdf',
}) => new Promise( _o_end1 => {
  if ( chkOS() == 'w' ) {
    if (navigator.userAgent.match(/Android/)) {
      if (pDz.url == 'pdf') {
        const _url = `https://docs.google.com/gview?embedded=true&url=${pDz.url}`; // PDF を表示する場合？
        window.open(encodeURI(_url), '_blank', 'location=yes,EnableViewPortScale=yes');
      }
      else {
        // https://groups.google.com/g/android-group-japan/c/UJHsmO3P0k4?pli=1
        setTimeout(() => { window.open(pDz.url, '_blank'); }, 100);
      }
    } else {
      window.open(pDz.url, '_blank')
    }
    _o_end1(null);
  }
  else {
    const _url =
      (pDz.tgt == 'tel') ?
       ('tel:' + String(hf.cvtHkk(pDz.url)).replace(/-/g, ''))
      : (pDz.tgt == 'mail') ?
       ('mailto:' + hf.cvtHkk(pDz.url))
      : pDz.url;
    Linking.openURL(_url);
    _o_end1(null);
  }
});
